const EXT_PATTERN = /(?:(?:\s+|\b)(?:ext(?:ension)?\.?|x)\s*[:.]?\s*)(\d+)\s*$/i;

function splitPhoneAndExtension(phoneNumber) {
  const value = `${phoneNumber ?? ''}`;
  const extMatch = value.match(EXT_PATTERN);
  if (!extMatch) {
    return { main: value, extension: '' };
  }
  return {
    main: value.slice(0, extMatch.index),
    extension: extMatch[1],
  };
}

function withExtension(formatted, extension) {
  if (!formatted || !extension) {
    return formatted;
  }
  return `${formatted} ext. ${extension}`;
}

function cleanPhoneNumber(phoneNumber) {
  return `${phoneNumber}`.replace(/\D/g, '');
}

function formatPhoneNumber(phoneNumber) {
  const { main, extension } = splitPhoneAndExtension(phoneNumber);
  const cleaned = cleanPhoneNumber(main);
  let match;
  if (cleaned.length === 7) {
    match = cleaned.match(/^(\d{3})(\d{4})$/);
  } else if (cleaned.length === 9) {
    match = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
  } else if (cleaned.length === 10) {
    match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  } else if (cleaned.length === 11) {
    match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
  } else {
    return null;
  }
  if (match) {
    let formatted;
    if (cleaned.length === 7) {
      formatted = `${match[1]}-${match[2]}`;
    } else if (cleaned.length === 9) {
      formatted = `${match[1]}-${match[2]}-${match[3]}`;
    } else if (cleaned.length === 10) {
      formatted = `(${match[1]}) ${match[2]}-${match[3]}`;
    } else if (cleaned.length === 11) {
      formatted = `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`;
    }
    return withExtension(formatted, extension);
  }
  return phoneNumber;
}

/**
 * Progressive US phone mask for form inputs (as-you-type).
 * Keeps partial values usable while typing; full 10/11-digit values match formatPhoneNumber.
 */
function formatPhoneInput(phoneNumber) {
  if (phoneNumber == null || phoneNumber === '') {
    return '';
  }
  const { main, extension } = splitPhoneAndExtension(phoneNumber);
  let digits = cleanPhoneNumber(main);
  if (!digits) {
    return '';
  }

  let prefix = '';
  if (digits.length > 10 && digits[0] === '1') {
    prefix = '+1 ';
    digits = digits.slice(1, 11);
  } else {
    digits = digits.slice(0, 10);
  }

  const area = digits.slice(0, 3);
  const mid = digits.slice(3, 6);
  const last = digits.slice(6, 10);

  let formatted;
  if (digits.length <= 3) {
    formatted = digits.length < 3 ? area : `(${area})`;
  } else if (digits.length <= 6) {
    formatted = `(${area}) ${mid}`;
  } else {
    formatted = `(${area}) ${mid}-${last}`;
  }

  return withExtension(`${prefix}${formatted}`, extension);
}

function parsePhoneNumber(phoneNumber) {
  if (typeof phoneNumber !== 'string') {
    return '';
  }
  const { main } = splitPhoneAndExtension(phoneNumber);
  const cleaned = cleanPhoneNumber(main);
  if (cleaned.length === 10) {
    return `+1${cleaned}`;
  } if (cleaned.length === 11 && cleaned[0] === '1') {
    return `+${cleaned}`;
  }
  return phoneNumber;
}
export { formatPhoneNumber, formatPhoneInput, parsePhoneNumber };
